import { Note } from "@e-forsyning/common/note";

import { MaalerAflaesning } from "./maaler-aflaesning.model";

export class MaalerAflaesningMedNoter extends MaalerAflaesning {
    public noter: Note[];
}
